module.exports = __webpack_public_path__ + "img/home-service-tianyi.c9165f17.png";